export default "__VITE_ASSET__Bx3ze9EE__"